import { render, staticRenderFns } from "./PrintElectricWater.vue?vue&type=template&id=bfa35b76"
import script from "./PrintElectricWater.vue?vue&type=script&lang=js"
export * from "./PrintElectricWater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports